import React, { useState, useEffect } from 'react';
import { Star,ChevronLeft, ChevronRight, Heart, Moon, Sparkles, Phone, Menu, X, ArrowLeft, MessageCircle, Flame, Lock, Eye, Wind, Zap, Shield } from 'lucide-react';

// Importar imagen local desde src/img/
import NumeAmorImg from './img/NumeAmor.jpg';
import AmarreAmorImg from './img/AmarreAmor.jpg';
import ShakrasImg  from './img/Shakras.jpg';
import TarotImg from './img/Tarot.jpg';
import LunaImg from './img/Luna.jpg';
import VidenciaImg from './img/videncia.jpg';
import SanacionImg from './img/SanacionEnergia.jpg';
import AmarreImg from './img/amarres.jpg';
import RetornoImg from './img/Retorno.jpg';
import EndulzaminetoImg from './img/endulzamiento.jpg';
import MaestroImg from './img/MaestroOrion.jpg';

// Componente de Carrusel de Testimonios
const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    { name: "María González", location: "Quito, Ecuador", img: "https://randomuser.me/api/portraits/women/44.jpg", text: "Mi ex regresó en solo 15 días completamente arrepentido. El amarre de amor del Maestro Orión funcionó a la perfección. Ahora estamos más enamorados que nunca y planeando nuestra boda. ¡Infinitamente agradecida!", service: "Amarre de Amor", stars: 5 },
    { name: "Carlos Ruiz", location: "Guayaquil, Ecuador", img: "https://randomuser.me/api/portraits/men/32.jpg", text: "El ritual de retorno fue increíble. Mi esposa volvió después de 2 meses de separación. El Maestro Orión no solo salvó mi matrimonio, cambió completamente mi vida. Su poder es real.", service: "Retorno de Pareja", stars: 5 },
    { name: "Ana Martínez", location: "Cuenca, Ecuador", img: "https://randomuser.me/api/portraits/women/68.jpg", text: "El endulzamiento trajo paz absoluta a mi relación. Las discusiones terminaron y ahora hay amor verdadero, comprensión mutua y armonía total en casa.", service: "Endulzamiento", stars: 5 },
    { name: "Jorge Pérez", location: "Ambato, Ecuador", img: "https://randomuser.me/api/portraits/men/52.jpg", text: "Después de 6 meses separados y sin esperanza, gracias al amarre mi pareja regresó rogando perdón. El trabajo del Maestro es 100% efectivo. Lo recomiendo completamente.", service: "Amarre de Compromiso", stars: 5 },
    { name: "Lucía Fernández", location: "Manta, Ecuador", img: "https://randomuser.me/api/portraits/women/28.jpg", text: "La lectura de tarot fue increíblemente precisa. El maestro predijo todo lo que pasaría y me guió perfectamente. Encontré el amor de mi vida tal como él lo vio en las cartas.", service: "Lectura de Tarot", stars: 5 },
    { name: "Roberto Díaz", location: "Loja, Ecuador", img: "https://randomuser.me/api/portraits/men/45.jpg", text: "El amarre funcionó en menos de 10 días. Mi novia no solo volvió, sino que ahora estamos comprometidos y planeando el futuro juntos. Gracias infinitas Maestro Orión.", service: "Amarre de Amor", stars: 5 },
    { name: "Patricia Silva", location: "Riobamba, Ecuador", img: "https://randomuser.me/api/portraits/women/32.jpg", text: "Recuperé a mi esposo después de que me dejara por otra mujer. El ritual de retorno es verdaderamente poderoso. Ahora somos más felices que antes.", service: "Retorno de Pareja", stars: 5 },
    { name: "Miguel Ángel", location: "Machala, Ecuador", img: "https://randomuser.me/api/portraits/men/67.jpg", text: "La limpieza espiritual eliminó todas las malas energías y envidias que me rodeaban. Mi vida cambió completamente para bien. Tengo paz, prosperidad y amor.", service: "Limpieza Espiritual", stars: 5 },
    { name: "Carmen López", location: "Portoviejo, Ecuador", img: "https://randomuser.me/api/portraits/women/55.jpg", text: "El amarre de compromiso hizo que mi pareja finalmente se decidiera a casarse después de 5 años juntos. ¡El Maestro Orión cumplió mi sueño!", service: "Amarre de Compromiso", stars: 5 },
    { name: "Fernando Castro", location: "Santo Domingo, Ecuador", img: "https://randomuser.me/api/portraits/men/28.jpg", text: "Después de probar con otros maestros sin resultado, solo el Maestro Orión logró traer resultados reales y rápidos. Mi ex volvió completamente transformada.", service: "Retorno de Pareja", stars: 5 }
  ];

  const itemsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalPages);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, totalPages]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalPages);
    setIsAutoPlaying(false);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalPages) % totalPages);
    setIsAutoPlaying(false);
  };

  const currentTestimonials = testimonials.slice(
    currentIndex * itemsPerPage,
    (currentIndex + 1) * itemsPerPage
  );

  return (
    <div className="relative">
      <div className="grid md:grid-cols-3 gap-8">
        {currentTestimonials.map((t, i) => (
          <div 
            key={i} 
            className="backdrop-blur-sm p-6 rounded-2xl border transform transition-all duration-500 hover:scale-105" 
            style={{ 
              backgroundColor: 'rgba(26, 31, 58, 0.4)', 
              borderColor: 'rgba(122, 106, 148, 0.3)',
              animation: 'fadeIn 0.5s ease-in'
            }}
          >
            <div className="flex items-center mb-4">
              <img 
                src={t.img} 
                alt={t.name} 
                className="w-16 h-16 rounded-full mr-4 object-cover" 
                style={{ border: '2px solid #b8975a' }} 
              />
              <div>
                <p className="font-semibold text-[#b8975a]">{t.name}</p>
                <p className="text-xs opacity-50">{t.location}</p>
                <div className="flex mt-1">
                  {[...Array(t.stars)].map((_, j) => (
                    <Star key={j} className="w-4 h-4 text-[#b8975a] fill-current" />
                  ))}
                </div>
                <p className="text-xs opacity-60 mt-1">{t.service}</p>
              </div>
            </div>
            <p className="italic opacity-90 text-sm leading-relaxed">"{t.text}"</p>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center mt-8 space-x-4">
        <button 
          onClick={prevSlide}
          className="p-3 rounded-full transition-all hover:scale-110"
          style={{ backgroundColor: 'rgba(184, 151, 90, 0.2)', border: '1px solid #b8975a' }}
        >
          <ChevronLeft className="w-6 h-6 text-[#b8975a]" />
        </button>

        <div className="flex space-x-2">
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => {
                setCurrentIndex(i);
                setIsAutoPlaying(false);
              }}
              className="w-3 h-3 rounded-full transition-all"
              style={{ 
                backgroundColor: i === currentIndex ? '#b8975a' : 'rgba(184, 151, 90, 0.3)',
                transform: i === currentIndex ? 'scale(1.2)' : 'scale(1)'
              }}
            />
          ))}
        </div>

        <button 
          onClick={nextSlide}
          className="p-3 rounded-full transition-all hover:scale-110"
          style={{ backgroundColor: 'rgba(184, 151, 90, 0.2)', border: '1px solid #b8975a' }}
        >
          <ChevronRight className="w-6 h-6 text-[#b8975a]" />
        </button>
      </div>

      <div className="text-center mt-4">
        <button 
          onClick={() => setIsAutoPlaying(!isAutoPlaying)}
          className="text-sm opacity-60 hover:opacity-100 transition"
        >
          {isAutoPlaying ? '⏸ Pausar' : '▶ Reproducir'}
        </button>
      </div>
    </div>
  );
};

export default function SpiritualGuidePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showLegalModal, setShowLegalModal] = useState(null);
  const [floatingPos, setFloatingPos] = useState({ x: 0, y: 0 });
  
  const handleConversion = () => {
    if (window.gtag_report_conversion) {
      return window.gtag_report_conversion('https://wa.me/593962861179?text=Hola%20Maestro%20Orion,%20necesito%20ayuda%20con%20un%20amarre%20de%20amor');
    }
  };

  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.backgroundColor = '#020408';
    document.documentElement.style.backgroundColor = '#020408';
    
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let time = 0;
    const interval = setInterval(() => {
      time += 0.05;
      setFloatingPos({ x: Math.sin(time) * 10, y: Math.cos(time * 0.5) * 10 });
    }, 50);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const blogPosts = [
    { 
      id: 1, 
      title: "Los 7 Chakras: Guía Completa para el Equilibrio Energético", 
      excerpt: "Descubre cómo los chakras influyen profundamente en tu bienestar físico, emocional y espiritual. Aprende a identificar bloqueos y desbalances energéticos.", 
      category: "Sanación", 
      readTime: "8 min",
      image: ShakrasImg
    },
    { 
      id: 2, 
      title: "Cómo Interpretar el Tarot: Secretos de las Cartas Revelados", 
      excerpt: "Guía práctica y profunda para entender el lenguaje oculto de las cartas del tarot. Descifra los mensajes del universo y tu destino.", 
      category: "Tarot", 
      readTime: "12 min",
      image: TarotImg
    },
    { 
      id: 3, 
      title: "Amarres de Amor Efectivos: La Verdad Sobre la Magia Blanca", 
      excerpt: "Todo lo que necesitas saber sobre amarres y hechizos de amor verdaderos. Rituales ancestrales que han unido a miles de parejas.", 
      category: "Amarres", 
      readTime: "15 min",
      image: AmarreAmorImg
    },
    { 
      id: 4, 
      title: "Rituales de Luna Llena: Aprovecha el Poder Lunar", 
      excerpt: "La energía lunar en su máximo esplendor. Aprende los rituales más poderosos para manifestar tus deseos durante la luna llena.", 
      category: "Rituales", 
      readTime: "9 min",
      image: LunaImg
    },
    { 
      id: 5, 
      title: "Retorno de Pareja: Cómo Recuperar al Amor de tu Vida", 
      excerpt: "Métodos comprobados y efectivos para traer de vuelta a tu ex con magia blanca. Testimonios reales de parejas reunidas.", 
      category: "Amarres", 
      readTime: "12 min",
      image: RetornoImg
    },
    { 
      id: 6, 
      title: "Numerología del Amor: El Poder Secreto de los Números", 
      excerpt: "Descubre el significado profundo de los números en el amor y las relaciones. Tu fecha de nacimiento revela tu compatibilidad perfecta.", 
      category: "Numerología", 
      readTime: "10 min",
      image: NumeAmorImg  
    }
  ];

  if (selectedArticle) {
    const article = blogPosts.find(p => p.id === selectedArticle);
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#020408] via-[#0a0e1a] to-[#020408] text-[#d4cfc4]">
        <div className="max-w-4xl mx-auto px-4 py-20">
          <button
            onClick={() => setSelectedArticle(null)}
            className="flex items-center space-x-2 text-[#b8975a] hover:opacity-80 mb-8 transition"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Volver al Blog</span>
          </button>

          <article
            className="backdrop-blur-sm rounded-3xl overflow-hidden border"
            style={{
              backgroundColor: 'rgba(26, 31, 58, 0.2)',
              borderColor: 'rgba(122, 106, 148, 0.3)'
            }}
          >
            <img src={article.image} alt={article.title} className="w-full h-96 object-cover" />
            <div className="p-8">
              <span
                className="inline-block px-4 py-1 rounded-full text-sm font-semibold mb-6"
                style={{ backgroundColor: 'rgba(184, 151, 90, 0.2)', color: '#b8975a' }}
              >
                {article.category}
              </span>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">
                {article.title}
              </h1>
              <p className="text-lg leading-relaxed mb-6">{article.excerpt}</p>
              <p className="text-base leading-relaxed opacity-90">
                Este es un artículo completo con información detallada y práctica sobre el tema.
                Contiene rituales, consejos y sabiduría ancestral para que puedas aplicar estos
                conocimientos en tu vida diaria.
              </p>
            </div>
          </article>
        </div>
        <a
        
          onClick={handleConversion}
          href="https://wa.me/593962861179?text=Hola%20Maestro%20Orion,%20necesito%20ayuda%20con%20un%20amarre%20de%20amor"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 bg-gradient-to-r from-green-600 to-green-700 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all z-50"
          style={{ transform: `translate(${floatingPos.x}px, ${floatingPos.y}px)` }}
        >
          <MessageCircle className="w-7 h-7" />
        </a>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020408] via-[#0a0e1a] to-[#020408] text-[#d4cfc4]">
      <nav className={`fixed w-full z-50 transition-all ${scrolled ? 'shadow-2xl' : ''}`} style={{ backgroundColor: scrolled ? 'rgba(2, 4, 8, 0.98)' : 'transparent', backdropFilter: scrolled ? 'blur(12px)' : 'none' }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-2">
              <Moon className="w-8 h-8 text-[#b8975a]" />
              <span className="text-xl font-bold bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">Maestro Orión</span>
            </div>
            <div className="hidden md:flex space-x-6">
              {['inicio', 'sobre-mi', 'servicios', 'amarres', 'blog', 'testimonios', 'contacto'].map(sec => (
                <button key={sec} onClick={() => scrollToSection(sec)} className="hover:text-[#b8975a] transition capitalize">{sec.replace('-', ' ')}</button>
              ))}
            </div>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden">
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
        {isMenuOpen && (
          <div className="md:hidden backdrop-blur-md px-2 pt-2 pb-3 space-y-1" style={{ backgroundColor: 'rgba(2, 4, 8, 0.98)' }}>
            {['inicio', 'sobre-mi', 'servicios', 'amarres', 'blog', 'testimonios', 'contacto'].map(sec => (
              <button key={sec} onClick={() => scrollToSection(sec)} className="block w-full text-left px-3 py-2 rounded capitalize hover:bg-[rgba(26,31,58,0.5)] transition">{sec.replace('-', ' ')}</button>
            ))}
          </div>
        )}
      </nav>

      <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-40">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#7a6a94] rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#b8975a] rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-[#8b4513] rounded-full filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        <div className="absolute top-20 left-1/2 transform -translate-x-1/2 z-10 w-full max-w-3xl px-4">
          <div className="rounded-lg p-4 text-center border" style={{ backgroundColor: 'rgba(26, 31, 58, 0.2)', borderColor: 'rgba(122, 106, 148, 0.3)' }}>
            <p className="text-sm text-[#7a6a94]">Espacio publicitario - Google AdSense 728x90</p>
          </div>
        </div>
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
          <div className="flex items-center justify-center space-x-4 mb-6">
            <Sparkles className="w-12 h-12 text-[#b8975a] animate-pulse" />
            <Moon className="w-16 h-16 text-[#7a6a94] animate-pulse" style={{ animationDelay: '0.5s' }} />
            <Sparkles className="w-12 h-12 text-[#b8975a] animate-pulse" style={{ animationDelay: '1s' }} />
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-[#b8975a] via-[#7a6a94] to-[#d4cfc4] bg-clip-text text-transparent">Maestro Orión</h1>
          <p className="text-2xl md:text-3xl mb-4 font-semibold text-[#b8975a]">Amarres de Amor Poderosos & Magia Blanca Ancestral</p>
          <p className="text-xl md:text-2xl mb-4 opacity-90">Guía espiritual con más de 20 años de experiencia</p>
          <p className="text-lg md:text-xl mb-8 opacity-80 max-w-2xl mx-auto">Rituales efectivos de sanación, amarres de amor y protección espiritual que han transformado miles de vidas en Ecuador y el mundo</p>
          
          <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto mb-8">
            <div className="backdrop-blur-sm p-4 rounded-xl" style={{ backgroundColor: 'rgba(184, 151, 90, 0.1)', border: '1px solid rgba(184, 151, 90, 0.3)' }}>
              <div className="text-3xl font-bold text-[#b8975a]">+5,000</div>
              <div className="text-sm opacity-80">Casos Exitosos</div>
            </div>
            <div className="backdrop-blur-sm p-4 rounded-xl" style={{ backgroundColor: 'rgba(184, 151, 90, 0.1)', border: '1px solid rgba(184, 151, 90, 0.3)' }}>
              <div className="text-3xl font-bold text-[#b8975a]">20+</div>
              <div className="text-sm opacity-80">Años de Experiencia</div>
            </div>
            <div className="backdrop-blur-sm p-4 rounded-xl" style={{ backgroundColor: 'rgba(184, 151, 90, 0.1)', border: '1px solid rgba(184, 151, 90, 0.3)' }}>
              <div className="text-3xl font-bold text-[#b8975a]">100%</div>
              <div className="text-sm opacity-80">Confidencial</div>
            </div>
          </div>

          <button 
            onClick={() => {
              handleConversion();
              scrollToSection('contacto');
            }}
            className="font-bold py-4 px-8 rounded-full hover:scale-105 transition-all shadow-lg" 
            style={{ background: 'linear-gradient(to right, #b8975a, #a08550)', color: '#020408', boxShadow: '0 10px 40px rgba(184, 151, 90, 0.4)' }}
          >
            <span className="flex items-center space-x-2">
              <MessageCircle className="w-5 h-5" />
              <span>Consulta Gratis por WhatsApp</span>
            </span>
          </button>
        </div>
      </section>

      <section id="sobre-mi" className="py-20 px-4">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div className="relative group">
            <div className="absolute inset-0 rounded-3xl blur-2xl opacity-50 group-hover:opacity-75 transition-opacity" style={{ background: 'linear-gradient(to bottom right, rgba(184, 151, 90, 0.3), rgba(122, 106, 148, 0.3))' }}></div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src={MaestroImg} 
                alt="Maestro Orión - Guía Espiritual"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#020408]/80 to-transparent"></div>
            </div>
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">Maestro Orión</h2>
            <p className="text-lg mb-4 opacity-90 leading-relaxed">
              Con más de <strong className="text-[#b8975a]">20 años de experiencia</strong> en amarres de amor y magia blanca ancestral, he dedicado mi vida a ayudar a miles de personas a recuperar el amor de su vida y encontrar la felicidad que merecen.
            </p>
            <p className="text-lg mb-4 opacity-90 leading-relaxed">
              Soy especialista reconocido en <strong className="text-[#b8975a]">amarres de amor efectivos</strong>, retornos de pareja, endulzamientos y protección espiritual. Trabajo únicamente con <strong className="text-[#b8975a]">magia blanca ancestral</strong>, respetando el libre albedrío y las leyes universales.
            </p>
            <p className="text-lg mb-6 opacity-90 leading-relaxed">
              He reunido a <strong className="text-[#b8975a]">más de 5,000 parejas</strong> y ayudado a fortalecer innumerables relaciones en Ecuador y alrededor del mundo. Mi compromiso es brindarte resultados reales con ética y profesionalismo.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="flex items-start space-x-3">
                <Shield className="w-6 h-6 text-[#b8975a] flex-shrink-0 mt-1" />
                <div>
                  <div className="font-semibold text-[#b8975a]">100% Confidencial</div>
                  <div className="text-sm opacity-75">Tu privacidad está protegida</div>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Zap className="w-6 h-6 text-[#b8975a] flex-shrink-0 mt-1" />
                <div>
                  <div className="font-semibold text-[#b8975a]">Resultados Rápidos</div>
                  <div className="text-sm opacity-75">Efectividad comprobada</div>
                </div>
              </div>
            </div>

            <button onClick={() => scrollToSection('contacto')} className="py-3 px-6 rounded-full font-semibold transition-all hover:scale-105" style={{ background: 'linear-gradient(to right, #b8975a, #8b4513)', color: '#020408' }}>
              Agenda tu Consulta Ahora
            </button>
          </div>
        </div>
      </section>

      <section id="servicios" className="py-20 px-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">Servicios Espirituales Profesionales</h2>
            <p className="text-xl opacity-80 max-w-3xl mx-auto">Descubre el poder transformador de la energía espiritual a través de mis servicios especializados</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { 
                icon: <Star className="w-12 h-12" />, 
                title: "Lectura de Tarot Profunda", 
                desc: "Descubre tu verdadero destino en el amor y la vida. Lecturas precisas que revelan tu futuro y te guían hacia las decisiones correctas. Incluye interpretación completa de arcanos mayores y menores.", 
                img: TarotImg,
                features: ["Predicción precisa", "Guía personalizada", "Respuestas claras"]
              },
              { 
                icon: <Heart className="w-12 h-12" />, 
                title: "Sanación Energética Completa", 
                desc: "Limpieza profunda de aura y equilibrio de chakras. Elimina bloqueos energéticos, malas vibras y energías negativas que afectan tu vida. Restablece tu paz interior y vitalidad.", 
                img: SanacionImg,
                features: ["Limpieza de aura", "Balance chakras", "Renovación energética"]
              },
              { 
                icon: <Eye className="w-12 h-12" />, 
                title: "Videncia y Clarividencia", 
                desc: "Consultas para ver tu destino con claridad absoluta. Conecto con el plano espiritual para revelarte información importante sobre tu presente y futuro. Respuestas directas a tus inquietudes más profundas.", 
                img: VidenciaImg,
                features: ["Visión del futuro", "Conexión espiritual", "Orientación divina"]
              }
            ].map((s, i) => (
              <div key={i} className="backdrop-blur-sm rounded-3xl border overflow-hidden hover:-translate-y-2 transition-all" style={{ backgroundColor: 'rgba(26, 31, 58, 0.4)', borderColor: 'rgba(122, 106, 148, 0.3)' }}>
                <img src={s.img} alt={s.title} className="w-full h-48 object-cover" />
                <div className="p-8">
                  <div className="text-[#b8975a] mb-4">{s.icon}</div>
                  <h3 className="text-2xl font-bold mb-4 text-[#b8975a]">{s.title}</h3>
                  <p className="opacity-90 mb-4 leading-relaxed">{s.desc}</p>
                  <div className="space-y-2 mb-4">
                    {s.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-2 text-sm">
                        <Star className="w-4 h-4 text-[#b8975a] fill-current" />
                        <span className="opacity-80">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <button onClick={() => scrollToSection('contacto')} className="w-full py-2 rounded-full text-sm font-semibold transition-all hover:scale-105" style={{ background: 'rgba(184, 151, 90, 0.2)', color: '#b8975a', border: '1px solid #b8975a' }}>
                    Consultar Ahora
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="amarres" className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <Flame className="w-16 h-16 mx-auto mb-4 text-[#b8975a] animate-pulse" />
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#b8975a] via-[#8b4513] to-[#7a6a94] bg-clip-text text-transparent">Amarres de Amor Poderosos y Efectivos</h2>
            <p className="text-xl opacity-90 max-w-3xl mx-auto mb-2">Rituales de magia blanca ancestral para recuperar y fortalecer el amor verdadero</p>
            <p className="opacity-75 max-w-2xl mx-auto">Trabajos espirituales con resultados comprobados. Miles de parejas reunidas gracias al poder de nuestros amarres.</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {[
              { 
                icon: <Heart className="w-16 h-16" />, 
                title: "Amarre de Amor Definitivo", 
                desc: "Ritual poderoso para atraer o recuperar el amor de tu vida. Este amarre trabaja directamente en el corazón de la persona amada, despertando sentimientos profundos y duraderos. Resultados visibles en 7-15 días.", 
                precio: "Consultar", 
                img: AmarreImg,
                beneficios: ["Atrae al ser amado", "Despierta sentimientos", "Amor duradero", "Resultados en 7-15 días"]
              },
              { 
                icon: <Lock className="w-16 h-16" />, 
                title: "Amarre de Compromiso Serio", 
                desc: "Fortalece relaciones y logra el compromiso definitivo. Ideal para parejas que necesitan dar el siguiente paso. Este trabajo espiritual elimina miedos, dudas e inseguridades sobre el compromiso y el matrimonio.", 
                precio: "Consultar", 
                img: "https://images.unsplash.com/photo-1474552226712-ac0f0961a954?w=600",
                beneficios: ["Elimina miedos al compromiso", "Fortalece la unión", "Matrimonio seguro", "Relación estable"]
              },
              { 
                icon: <Flame className="w-16 h-16" />, 
                title: "Retorno de Pareja Urgente", 
                desc: "Tu ex regresará completamente arrepentido y transformado. El ritual más poderoso para traer de vuelta a quien se fue. Trabaja eliminando obstáculos, terceras personas y malas influencias. Efectividad del 98%.", 
                precio: "Consultar", 
                img: RetornoImg,
                beneficios: ["Regreso garantizado", "Elimina terceras personas", "Arrepentimiento genuino", "Reconciliación total"]
              },
              { 
                icon: <Wind className="w-16 h-16" />, 
                title: "Endulzamiento de Pareja", 
                desc: "Mejora la comunicación, elimina peleas y restaura el afecto perdido. Endulza el carácter de tu pareja y trae paz, armonía y comprensión mutua a la relación. Perfecto para salvar matrimonios en crisis.", 
                precio: "Consultar", 
                img: EndulzaminetoImg,
                beneficios: ["Elimina discusiones", "Restaura el amor", "Paz en el hogar", "Armonía total"]
              }
            ].map((a, i) => (
              <div key={i} className="backdrop-blur-md rounded-3xl border overflow-hidden group" style={{ backgroundColor: 'rgba(26, 31, 58, 0.6)', borderColor: 'rgba(184, 151, 90, 0.4)' }}>
                <div className="relative overflow-hidden">
                  <img src={a.img} alt={a.title} className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#020408]/60 to-transparent"></div>
                </div>
                <div className="p-8">
                  <div className="text-[#b8975a] mb-4">{a.icon}</div>
                  <h3 className="text-2xl font-bold mb-4 text-[#b8975a]">{a.title}</h3>
                  <p className="opacity-90 mb-6 leading-relaxed">{a.desc}</p>
                  
                  <div className="mb-6 space-y-2">
                    <p className="text-sm font-semibold text-[#b8975a] mb-2">Beneficios Garantizados:</p>
                    {a.beneficios.map((beneficio, idx) => (
                      <div key={idx} className="flex items-center space-x-2 text-sm">
                        <Sparkles className="w-4 h-4 text-[#b8975a]" />
                        <span className="opacity-85">{beneficio}</span>
                      </div>
                    ))}
                  </div>

                  <button onClick={() => scrollToSection('contacto')} className="w-full py-3 rounded-full font-semibold transition-all hover:scale-105 hover:shadow-xl" style={{ background: 'linear-gradient(to right, #b8975a, #8b4513)', color: '#020408' }}>
                    Solicitar {a.title}
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center backdrop-blur-sm p-8 rounded-3xl" style={{ backgroundColor: 'rgba(184, 151, 90, 0.1)', border: '1px solid rgba(184, 151, 90, 0.3)' }}>
            <Shield className="w-12 h-12 mx-auto mb-4 text-[#b8975a]" />
            <h3 className="text-2xl font-bold mb-3 text-[#b8975a]">Garantía y Compromiso</h3>
            <p className="opacity-90 max-w-2xl mx-auto leading-relaxed">
              Todos nuestros trabajos están respaldados por años de experiencia y miles de casos exitosos. 
              Trabajamos con <strong>magia blanca pura</strong>, sin daño a terceros. Tu satisfacción y resultados son nuestra prioridad. 
              Primera consulta completamente <strong>GRATIS</strong> para evaluar tu caso.
            </p>
          </div>
        </div>
      </section>

      <section id="blog" className="py-20 px-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">Blog Espiritual y Sabiduría Ancestral</h2>
            <p className="text-xl opacity-80 max-w-3xl mx-auto">Artículos, guías y conocimientos milenarios para tu crecimiento espiritual</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {blogPosts.map(p => (
              <article key={p.id} onClick={() => setSelectedArticle(p.id)} className="backdrop-blur-sm rounded-2xl border overflow-hidden cursor-pointer transition-all hover:border-[rgba(184,151,90,0.5)] hover:-translate-y-2 group" style={{ backgroundColor: 'rgba(26, 31, 58, 0.3)', borderColor: 'rgba(122, 106, 148, 0.3)' }}>
                <div className="relative overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute top-4 right-4 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold" style={{ backgroundColor: 'rgba(184, 151, 90, 0.9)', color: '#020408' }}>
                    {p.readTime}
                  </div>
                </div>
                <div className="p-6">
                  <span className="text-sm font-semibold text-[#b8975a]">{p.category}</span>
                  <h3 className="text-xl font-bold my-3 group-hover:text-[#b8975a] transition-colors">{p.title}</h3>
                  <p className="opacity-75 text-sm leading-relaxed">{p.excerpt}</p>
                  <div className="mt-4 flex items-center text-[#b8975a] text-sm font-semibold group-hover:translate-x-2 transition-transform">
                    <span>Leer más</span>
                    <ArrowLeft className="w-4 h-4 ml-2 rotate-180" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="testimonios" className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">
            Testimonios Reales de Éxito
          </h2>
          <p className="text-center mb-4 text-xl opacity-90">
            Más de 5,000 personas han recuperado el amor de su vida
          </p>
          <p className="text-center mb-12 opacity-75 max-w-2xl mx-auto">
            Lee las experiencias reales de quienes confiaron en el Maestro Orión y transformaron sus vidas completamente
          </p>
          <TestimonialsCarousel />
        </div>
      </section>

      <section id="contacto" className="py-20 px-4">
        <div className="max-w-md mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#b8975a] to-[#7a6a94] bg-clip-text text-transparent">
            ¿Listo para Recuperar tu Amor?
          </h2>
          <p className="text-lg mb-8 opacity-90">
            Primera consulta completamente GRATIS. Sin compromiso.
          </p>

          <div
            className="backdrop-blur-sm p-8 rounded-3xl border"
            style={{ backgroundColor: 'rgba(26, 31, 58, 0.5)', borderColor: 'rgba(184, 151, 90, 0.4)' }}
          >
            <Phone className="w-16 h-16 mx-auto mb-4 text-[#b8975a] animate-pulse" />
            <p className="text-xl font-semibold mb-2">Atención Personal 24/7</p>
            <p className="mb-2 opacity-80">Respuesta inmediata garantizada</p>
            <p className="mb-6 text-sm opacity-70">Consulta 100% confidencial y profesional</p>

            <a
            
              onClick={handleConversion}
              href="https://wa.me/593962861179?text=Hola%20Maestro%20Orion,%20necesito%20ayuda%20con%20un%20amarre%20de%20amor"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 font-bold py-4 px-8 rounded-full hover:scale-105 transition-all shadow-2xl"
              style={{ background: 'linear-gradient(to right, #25D366, #128C7E)', color: '#ffffff' }}
            >
              <Phone className="w-5 h-5" />
              <span>Consulta Gratis por WhatsApp</span>
            </a>

            <p className="mt-4 text-xs opacity-60">+593 96 286 1179</p>
          </div>
        </div>
      </section>

      <footer className="py-12 px-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-[#b8975a] font-bold mb-4">Maestro Orión</h3>
              <p className="text-sm opacity-80 leading-relaxed">Experto en amarres de amor y magia blanca ancestral. Más de 20 años ayudando a personas en Ecuador y el mundo.</p>
            </div>
            <div>
              <h3 className="text-[#b8975a] font-bold mb-4">Servicios</h3>
              <ul className="space-y-2 text-sm opacity-80">
                <li>Amarres de Amor</li>
                <li>Retorno de Pareja</li>
                <li>Endulzamientos</li>
                <li>Limpieza Espiritual</li>
                <li>Lectura de Tarot</li>
              </ul>
            </div>
            <div>
              <h3 className="text-[#b8975a] font-bold mb-4">Legal</h3>
              <ul className="space-y-2 text-sm opacity-80">
                <li><button onClick={() => setShowLegalModal('privacy')} className="hover:text-[#b8975a]">Política de Privacidad</button></li>
                <li><button onClick={() => setShowLegalModal('terms')} className="hover:text-[#b8975a]">Términos y Condiciones</button></li>
              </ul>
            </div>
            <div>
              <h3 className="text-[#b8975a] font-bold mb-4">Contacto</h3>
              <p className="text-sm opacity-80 mb-2">WhatsApp 24/7</p>
              <p className="text-sm opacity-80 mb-2">+593 96 286 1179</p>
              <p className="text-sm opacity-80">Atención en toda Ecuador</p>
            </div>
          </div>
          <div className="border-t pt-8 text-center" style={{ borderColor: '#1a1f3a' }}>
            <p className="text-[#7a6a94] text-sm">© 2026 Maestro Orión - Todos los derechos reservados</p>
            <p className="text-xs opacity-60 mt-2">Servicios espirituales profesionales desde 2005</p>
          </div>
        </div>
      </footer>

      {showLegalModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}>
          <div className="rounded-3xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" style={{ background: '#0a0e1a', border: '1px solid #7a6a94' }}>
            <div className="flex justify-between items-center mb-6 sticky top-0 pb-4" style={{ background: '#0a0e1a' }}>
              <h2 className="text-2xl font-bold text-[#b8975a]">
                {showLegalModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setShowLegalModal(null)} className="text-white hover:text-[#b8975a]">
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="text-white space-y-4 text-sm leading-relaxed">
              {showLegalModal === 'privacy' ? (
                <>
                  <p className="text-xs text-gray-400 mb-4">Última actualización: Enero 2026</p>
                  
                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">1. INFORMACIÓN QUE RECOPILAMOS</h3>
                    <p className="opacity-80">Recopilamos tu nombre, email, teléfono, información de consulta, datos de navegación (IP, navegador, páginas visitadas) y cookies.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">2. CÓMO USAMOS TU INFORMACIÓN</h3>
                    <p className="opacity-80">Usamos tu información para prestarte el servicio solicitado, procesar pagos, comunicarnos contigo, mejorar nuestros servicios, enviar promociones (si aceptas) y mostrar anuncios con Google AdSense.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">3. COOKIES</h3>
                    <p className="opacity-80">Usamos cookies para que el sitio funcione correctamente, analizar cómo usas el sitio (Google Analytics) y mostrar anuncios personalizados (Google AdSense). Puedes desactivar las cookies en tu navegador.</p>
                    <p className="opacity-60 text-xs mt-2">Gestiona anuncios: google.com/settings/ads</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">4. COMPARTIMOS INFORMACIÓN CON</h3>
                    <p className="opacity-80">Compartimos información con plataformas de pago, Google AdSense y Analytics, y autoridades si la ley lo requiere. NO vendemos tu información a terceros.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">5. TUS DERECHOS (Ley 1581 de 2012 - Colombia)</h3>
                    <p className="opacity-80">Puedes acceder, corregir, eliminar tus datos o revocar tu autorización contactándonos. Responderemos en 15 días hábiles.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">6. SEGURIDAD</h3>
                    <p className="opacity-80">Protegemos tu información con encriptación y medidas de seguridad, pero ningún sistema es 100% seguro.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">7. MENORES DE EDAD</h3>
                    <p className="opacity-80">No recopilamos información de menores de 18 años.</p>
                  </div>

                  <div className="bg-[#7a6a94] bg-opacity-20 p-4 rounded-lg mt-4">
                    <p className="text-[#b8975a] font-semibold">Al usar nuestros servicios autorizas el tratamiento de tus datos según esta política.</p>
                  </div>
                </>
              ) : (
                <>
                  <p className="text-xs text-gray-400 mb-4">Última actualización: Enero 2026</p>
                  
                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">1. ACEPTACIÓN</h3>
                    <p className="opacity-80">Al usar este sitio web aceptas estos términos. Si no estás de acuerdo, no uses nuestros servicios.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">2. SERVICIOS</h3>
                    <p className="opacity-80">Ofrecemos servicios espirituales como lecturas de tarot, amarres de amor y consultas. Estos servicios son de orientación y entretenimiento, no sustituyen consejo médico, legal o psicológico profesional.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">3. NATURALEZA DE LOS SERVICIOS</h3>
                    <p className="opacity-80">Los servicios son orientativos. No garantizamos resultados específicos. Las decisiones importantes debes tomarlas con tu propio criterio. Los resultados pueden variar según cada persona.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">4. USO DEL SITIO</h3>
                    <p className="opacity-80">Debes dar información verdadera, usar el sitio de forma responsable, no hacer actividades ilegales y respetar el contenido del sitio.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">5. PAGOS Y RESERVAS</h3>
                    <p className="opacity-80">Las reservas se confirman con pago anticipado. Los precios pueden cambiar sin aviso previo. Usamos plataformas de pago seguras.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">6. CANCELACIONES</h3>
                    <p className="opacity-80">Cancela con 24 horas de anticipación. No hay reembolsos por servicios ya prestados. Si nosotros cancelamos, puedes reagendar o pedir reembolso.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">7. CONFIDENCIALIDAD</h3>
                    <p className="opacity-80">Mantenemos privada la información de tus consultas.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">8. RESPONSABILIDAD</h3>
                    <p className="opacity-80">No somos responsables de decisiones que tomes basándote en las consultas, resultados no obtenidos o problemas técnicos del sitio.</p>
                  </div>

                  <div>
                    <h3 className="text-[#b8975a] font-semibold mb-2">9. EDAD</h3>
                    <p className="opacity-80">Debes ser mayor de 18 años para usar nuestros servicios.</p>
                  </div>

                  <div className="bg-[#7a6a94] bg-opacity-20 p-4 rounded-lg mt-4">
                    <p className="text-[#b8975a] font-semibold">Al usar nuestros servicios aceptas estos términos completamente.</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      
        <a
        onClick={handleConversion}
        href="https://wa.me/593962861179?text=Hola%20Maestro%20Orion,%20necesito%20ayuda%20con%20un%20amarre%20de%20amor"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-gradient-to-r from-green-600 to-green-700 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all z-50"
        style={{ transform: `translate(${floatingPos.x}px, ${floatingPos.y}px)` }}
      >
        <MessageCircle className="w-7 h-7" />
      </a>
    </div>
  );
}